const ProposalsRoutes = {
  getAllProposals: "/proposal/getAllProposal",
}

export default ProposalsRoutes;